import paycoUtils from '@/assets/js/utils'

interface IReceiver {
  receiverName? : string;
  receiverTelNo : string;
  ticketCount: number;
}

class Receiver {
  constructor(args: IReceiver) {
    return Object.assign(this, args);
  }

  get displayedName(): string | undefined {
    if (!paycoUtils.isEmptyString(this.receiverName)) {
      return this.receiverName;
    }
    return this.receiverTelNo;
  }

  get isValidPhoneNumber(): boolean {
    const validPhoneNumberRegExp = /^01([0|1|6|7|8|9])\d{7,8}$/;
    return validPhoneNumberRegExp.test(this.receiverTelNo);
  }
}

interface Receiver extends IReceiver {
}

export default Receiver;
